// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__2AzBX","children":"styles_children__1JDIs","btn_disabled":"styles_btn_disabled__1rd-y","targetBtn":"styles_targetBtn__35LKn"};